import * as runtime from '../runtime'
import { HTTPBody } from '../runtime'

export type Keyword = {
  key: string
  tag: string
  word: string
}

export type SeparateKeyword = {
  key: string
  tag: string
  word: string
  value: string
}

export type SeparateKanaRequest = {
  keywords: Keyword[]
}

export function SeparateKanaRequestToJSON(value: SeparateKanaRequest): any {
  return {
    keywords: value.keywords.map(keyword => {
      return {
        key: keyword.key,
        tag: keyword.tag,
        word: keyword.word
      }
    })
  }
}

export class SeparateApi extends runtime.BaseAPI {
  async separateKana(request: SeparateKanaRequest): Promise<SeparateKeyword[]> {
    const body: HTTPBody = SeparateKanaRequestToJSON(request)

    const response = await this.requestPost(`/separate/kana`, body)

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue).value()
  }
}
